import React from 'react';

import { Grid, IconButton, Button, CloseIcon } from '@gogame/components';
import { FormFieldGroup, withArrayFormField } from '@gogame/form';

import FieldByType from './FieldByType';

const FieldSetArray = withArrayFormField()(
  ({ properties, description, value, push, remove }) => {
    const handleAddItem = React.useCallback(() => {
      push({});
    }, [push]);

    return (
      <React.Fragment>
        {value?.map((_item, index) => (
          <FormFieldGroup name={`[${index}]`} key={index}>
            <Grid xs={12} />
            {Object.keys(properties).map((propertyName, i, array) => {
              const { description, type } = properties[propertyName];
              return (
                <Grid item xs={i === 0 ? 4 : array.length > 2 ? 3 : 6} key={i}>
                  <FieldByType
                    name={propertyName}
                    label={description}
                    type={type}
                    padding={0}
                  />
                </Grid>
              );
            })}
            <Grid item xs={1}>
              <IconButton
                icon={<CloseIcon />}
                tooltip={'Remove'}
                onClick={() => remove(index)}
              />
            </Grid>
          </FormFieldGroup>
        ))}
        <Grid item xs={12}>
          <Button add color={'primary'} onClick={handleAddItem}>
            {description}
          </Button>
        </Grid>
      </React.Fragment>
    );
  }
);

export default FieldSetArray;
